var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-gray-600 text-base flex items-center border-b"},_vm._l((_vm.menuItems),function(item,index){return _c('div',{key:`tab-menu-item-${index}`,staticClass:"text-center w-32 cursor-pointer hover:text-atlas-blue",class:{
      'text-atlas-blue font-semibold border-b-2 border-atlas-blue':
        _vm.selectedTabKey === item.key,
      'mr-4': _vm.menuItems.length !== index
    },on:{"click":function($event){return _vm.$emit('tabClicked', item.key)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }